import React, { useEffect, useState } from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import queryString from 'query-string';

import StoreProvider from 'components/StoreProvider/StoreProvider';
import api from 'api';
import { parseTranslation } from 'utils';

import { InjectIntlProviderContext } from './hooks/InjectIntlProviderContext';
import { AuthState } from '../../store/modules/auth/auth';
import { ReduxState } from '../../store/store';

const { connect, selectors, actions, useSelector } = StoreProvider;

interface IntlProviderProps {
  children: React.ReactNode;
  language: string;
  setLanguage: (language: string) => void;
}

const IntlProvider = ({
  children,
  language,
  setLanguage,
}: IntlProviderProps) => {
  const [messages, setMessages] = useState({});
  const [intlLoaded, setIntlLoaded] = useState(false);
  const parsedSearch = queryString.parse(window.location.search);
  const { user } = useSelector<ReduxState, AuthState>((state) => state.auth);

  const getTranslations = (language_code: string) =>
    api.resources.getTranslations({ language_code }).then(({ data }) => {
      const parsedMessages = parseTranslation(data);

      setMessages(parsedMessages);
      setIntlLoaded(true);
    });

  useEffect(() => {
    if (user.language) {
      setLanguage(user.language);
    } else if (parsedSearch.lang) {
      setLanguage(parsedSearch.lang as string);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.language]);

  useEffect(() => {
    getTranslations(language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  if (!intlLoaded) {
    return null;
  }

  return (
    <ReactIntlProvider
      locale={language}
      messages={messages}
      defaultRichTextElements={{
        p: (chunks) => <p>{chunks}</p>,
      }}
    >
      <InjectIntlProviderContext>{children}</InjectIntlProviderContext>
    </ReactIntlProvider>
  );
};

export default connect(
  (state) => ({
    language: selectors.intlSelectors.language(state),
  }),
  {
    setLanguage: actions.intlActions.setLanguage,
  }
)(IntlProvider);
